import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  {
    path: '',
    children: [
      {
        path: 'recovery',
        loadComponent: () =>
          import('./recovery.component').then((m) => m.RecoveryComponent),
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class recoveryRoutingModule {
  static routes = admin;
}
